import { render } from "./removeUser.vue?vue&type=template&id=19c44f2c"
import script from "./removeUser.vue?vue&type=script&lang=js"
export * from "./removeUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__